import { makeAutoObservable, runInAction } from "mobx";
import agent from "../api/agent";
import { PendingSignUpRequest, SubPartnersKobHoved, Ta1AdminKobhovedPartnerFormValue, Ta1PartnerKobhoved, TempPartnerSignup } from "../models/partners";
import { toast } from "react-toastify";

export default class PartnerStore {

  partnerKobhoveds: Ta1PartnerKobhoved[] = [];
  partnerKobhovedsLoading = false;
  selectedPartnerKobhoved: Ta1PartnerKobhoved | null = null;
  isSelectAll = false;
  isSubPartnerSelectAll = false;
  subPartnerKobhoveds: SubPartnersKobHoved[] = [];
  subPartnerKobhovedsLoading = false;
  selectedSubPartnerKobhoved: SubPartnersKobHoved | null = null;
  adminPartnerTempKbhoveds: TempPartnerSignup[] = [];
  adminPartnerTempLoading = false;
  resendEmailTempLoading = false;
  deleteEmailTempLoading = false;

  activeTab: number = 0;

  loadingTestMail = false;

  partnerPendingReqs: PendingSignUpRequest[] = [];
  partnerPendingReqsLoading = false;

  constructor() {
    makeAutoObservable(this);
  }

  setActiveTab = (activeIndex: number) => {
    this.activeTab = activeIndex;
  };

  resetPartnerStore = () => {
    this.setActiveTab(0);
    this.partnerKobhoveds = [];
    this.selectedPartnerKobhoved = null;
    this.adminPartnerTempKbhoveds = [];
  }

  selectAllHandler = () => {
    if (this.partnerKobhoveds.length > 0) {
      const filteredData = [...this.partnerKobhoveds];

      filteredData.forEach((data) => {
        data.isChecked = !this.isSelectAll;
      })

      runInAction(() => {
        this.partnerKobhoveds = filteredData;
        this.isSelectAll = !this.isSelectAll;
      })
    }
  }

  partnerKobhovedCheckHandler = (id: string) => {
    if (id && this.partnerKobhoveds.length > 0) {
      const filteredData = [...this.partnerKobhoveds];
      let index = filteredData.findIndex(x => x.id === id);
      if (index >= 0) {
        let item = filteredData[index];
        item = {
          ...item,
          isChecked: !item.isChecked
        };
        filteredData[index] = item;
        const isSelectAll = filteredData.every(x => x.isChecked);
        runInAction(() => {
          this.partnerKobhoveds = filteredData;
          this.isSelectAll = isSelectAll;
        })
      }
    }
  }

  setSelectedPartnerKobhoved = (kobhoved: Ta1PartnerKobhoved | null) => {
    if (kobhoved) {
      runInAction(() => this.selectedPartnerKobhoved = kobhoved)
    } else {
      runInAction(() => this.selectedPartnerKobhoved = null)
    }
  }
  // loadPartnerKobhoveds = async () => {
  //   this.partnerKobhovedsLoading = true;
  //   this.partnerKobhoveds = [];
  //   try {
  //     const response = await agent.Partner.getPartnerKobhoveds();
  //     runInAction(() => {
  //       response.forEach((element: Ta1PartnerKobhoved) => {
  //         element.isChecked = false;
  //       });

  //       this.partnerKobhoveds = response;
  //       this.partnerKobhovedsLoading = false;
  //     });
  //   } catch (error) {
  //     console.log(error);
  //     runInAction(() => (this.partnerKobhovedsLoading = false));
  //   }
  // };
  loadAdminPartnerTempKobhoveds = async () => {
    this.adminPartnerTempLoading = true;
    this.adminPartnerTempKbhoveds = [];
    try {
      const response = await agent.Admin.getTempPartner();

      runInAction(() => {
        this.adminPartnerTempKbhoveds = response;
        this.adminPartnerTempLoading = false;
      });
    } catch (error) {
      console.log(error);
      runInAction(() => (this.adminPartnerTempLoading = false));
    }
  };

  resendEmailTempsignup = async (id: string) => {
    this.resendEmailTempLoading = true;
    try {
      await agent.Admin.resendTempPartnerEmail(id);
      runInAction(() => {
        this.resendEmailTempLoading = false;
      });
      toast.success("Email has been sent successfully");
    } catch (error) {
      console.log(error);
      runInAction(() => (this.resendEmailTempLoading = false));
      toast.success("Problem to send email, Try again");
    }
  };

  deleteEmailTempSignup = async (id: string) => {
    this.deleteEmailTempLoading = true;
    try {
      await agent.Admin.deleteTempPartner(id);
      runInAction(() => {
        const adminPartnerTempKbhoveds = this.adminPartnerTempKbhoveds.filter(x => x.id !== id);
        this.adminPartnerTempKbhoveds = adminPartnerTempKbhoveds;
        this.deleteEmailTempLoading = false;
      });
      toast.success("Partner has been deleted successfully");
    } catch (error) {
      console.log(error);
      runInAction(() => (this.deleteEmailTempLoading = false));
      toast.success("Problem to delete Partner, Try again");
    }
  };
  createPartner = async (formValues: Ta1AdminKobhovedPartnerFormValue) => {
    this.partnerKobhovedsLoading = true;
    try {
      await agent.Admin.addNewPartner(formValues);
      runInAction(() => {
        this.partnerKobhovedsLoading = false;
      });
      this.loadSubPartnerKobhoved();

    } catch (error) {
      runInAction(() => (this.partnerKobhovedsLoading = false));
      //It is important to through error so we can display them under/in the form
      throw error;
    }
  }

  loadSubPartnerKobhoved = async () => {
    this.subPartnerKobhovedsLoading = true;
    this.subPartnerKobhoveds = [];
    try {
      const response = await agent.Partner.getSubPartnerRequests();
      runInAction(() => {
        response.forEach((element: SubPartnersKobHoved) => {
          element.isChecked = false;
        });
        this.subPartnerKobhoveds = response;
        this.subPartnerKobhovedsLoading = false;
      });
    } catch (error) {
      runInAction(() => (this.subPartnerKobhovedsLoading = false));
      //It is important to through error so we can display them under/in the form
      throw error;
    }
  }
  subPartnerSelectAllHandler = () => {
    if (this.subPartnerKobhoveds.length > 0) {
      const filteredData = [...this.subPartnerKobhoveds];

      filteredData.forEach((data) => {
        data.isChecked = !this.isSubPartnerSelectAll;
      })

      runInAction(() => {
        this.subPartnerKobhoveds = filteredData;
        this.isSubPartnerSelectAll = !this.isSubPartnerSelectAll;
      })
    }
  }
  subPartnerKobhovedCheckHandler = (id: string) => {
    if (id && this.subPartnerKobhoveds.length > 0) {
      const filteredData = [...this.subPartnerKobhoveds];
      let index = filteredData.findIndex(x => x.id === id);
      if (index >= 0) {
        let item = filteredData[index];
        item = {
          ...item,
          isChecked: !item.isChecked
        };
        filteredData[index] = item;
        const isSubPartnerSelectAll = filteredData.every(x => x.isChecked);
        runInAction(() => {
          this.subPartnerKobhoveds = filteredData;
          this.isSubPartnerSelectAll = isSubPartnerSelectAll;
        })
      }
    }
  }
  loadPartnerPendingReqs = async () => {
    this.partnerPendingReqsLoading = true;
    this.partnerPendingReqs = [];
    try {
      const response = await agent.Partner.getPendingPartnerRequests();
      runInAction(() => {
        this.partnerPendingReqs = response;
        this.partnerPendingReqsLoading = false;
      });
    } catch (error) {
      console.log(error);
      runInAction(() => (this.partnerPendingReqsLoading = false));
    }
  };

}
